// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4a660049","425":"cd15ce7d","510":"8fa036a8","532":"414d80e7","633":"f1e4b1cb","634":"b0e485c6","922":"acea7b3b","937":"c48773fd","972":"1538e028"}[chunkId] + ".chunk.js";
};